// extracted by mini-css-extract-plugin
export default {"cls1":"PaperAbstract-cls1_u8_","cls2":"PaperAbstract-cls2_DRf PaperAbstract-cls1_u8_"};